import {
  WhmAlert,
  WhmButton,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import React from "react";

interface ContentRestrictedComponentProps {
  image: React.ReactElement;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  comment?: React.ReactNode;
  onCTAClick?: () => void;
  ctaText?: React.ReactNode;
  alertText?: React.ReactNode;
}

export const GenericContentRestricted: React.FC<
  ContentRestrictedComponentProps
> = ({ image, title, subtitle, comment, onCTAClick, ctaText, alertText }) => {
  return (
    <WhmStack
      padding={{ xs: "24px 0", xl: "24px 100px" }}
      alignItems="center"
      gap="16px"
    >
      {React.cloneElement(image, { style: { height: "124px" } })}
      <WhmStack gap="8px">
        <WhmTypography variant="h4" sx={{ textAlign: "center" }}>
          {title}
        </WhmTypography>
        <WhmTypography variant="body1" sx={{ textAlign: "center" }}>
          {subtitle}
        </WhmTypography>
      </WhmStack>
      {comment && (
        <WhmTypography
          variant="body1"
          sx={{ textAlign: "center", color: whmTheme.palette.text.secondary }}
        >
          {comment}
        </WhmTypography>
      )}
      {Boolean(ctaText) && (
        <WhmButton
          onClick={onCTAClick}
          variant="contained"
          color="primary"
          data-test-id="profile-content-restricted-cta"
          sx={{ marginTop: "8px", width: { xs: "100%", lg: "unset" } }}
        >
          {ctaText}
        </WhmButton>
      )}
      {Boolean(alertText) && (
        <WhmAlert
          severity="warning"
          variant="standard"
          icon={false}
          data-test-id="profile-content-restricted-alert"
        >
          {alertText}
        </WhmAlert>
      )}
    </WhmStack>
  );
};
